// 初期化関連
import * as formats from './formats.js';

$(() => {
    // ajax共通設定
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    // tooltip
    $('[data-toggle="tooltip"]').tooltip();

    setupConvertInputData();
    preventDoubleClick();
    preventUnload();
});


// 入力データフォーマット変換処理
function setupConvertInputData() {

    // focus/blur時のデータ変換
	$(document).on("focus", '.js-data-price', function(e) {
        $(this).val(formats.convertNum($(this).val()));
	});
	$(document).on("blur", '.js-data-price', function(e) {
        $(this).val(formats.convertPrice($(this).val()));
	});
	$(document).on("focus", '.js-data-price-not-text', function(e) {
        $(this).val(formats.convertNum($(this).val()));
	});
	$(document).on("blur", '.js-data-price-not-text', function(e) {
        $(this).val(formats.convertPriceNotText($(this).val()));
	});
	$(document).on("focus", '.js-data-hour', function(e) {
        $(this).val(formats.convertNum($(this).val()));
	});
	$(document).on("blur", '.js-data-hour', function(e) {
        $(this).val(formats.convertHour($(this).val()));
	});
    $(document).on("focus", '.js-data-1000sep', function(e) {
        $(this).val(formats.convertNum($(this).val()));
    });
    $(document).on("blur", '.js-data-1000sep', function(e) {
        $(this).val(formats.convert1000Separator($(this).val()));
    });
    $(document).on("blur", '.js-data-phone', function(e) {
        $(this).val(formats.convertPhoneNum($(this).val()));
    });

    $('.js-form-submit').on("click", function(e) {
        // 送信時時のデータ変換
        $('.js-data-price').each(function(i, e) {
            $(e).val(formats.convertNum($(e).val()));
        });
        $('.js-data-price-not-text').each(function(i, e) {
            $(e).val(formats.convertNum($(e).val()));
        });
        $('.js-data-hour').each(function(i, e) {
            $(e).val(formats.convertNum($(e).val()));
        });
        $('.js-data-1000sep').each(function(i, e) {
            $(e).val(formats.convertNum($(e).val()));
        });
    });
}

// ２重送信制御
function preventDoubleClick() {
    $('.js-form-submit').on("click", function() {
        window.js_form_submit = true;
        $(this).prop('disabled', true);

        // モーダル内ボタンがトリガーでページ本体のform を送信する時
        if($(this).parents('.modal-footer').length > 0) {
            $('#form').submit();
            return;
        }
        // ボタンを内包するフォームのみを送信
        $(this).parents('form').submit();
        return;
    });

    $('.js-anchor-click').on('click', function() {
        $(this).addClass('disabled');
    });
}

// ページアンロード時の制御
function preventUnload() {
    if ($('.js-before-unload').length > 0) {
        // ブラウザバック、タブ閉じなどの時にsubmit以外のボタンによる画面遷移でモーダルを出す(ブラウザ標準)
        window.addEventListener('beforeunload', (e) => {
            let message = null;
            if (!window.js_form_submit) {
                message = '';
                e.preventDefault();
                e.returnValue = message;
            }
            return message;
        });
    }
}